var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[(_vm.isLoggedIn)?_c('PrivateMenu'):_c('PublicMenu'),_c('LoginMenu',{attrs:{"isLoggedIn":_vm.isLoggedIn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }